"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GroupEvent = void 0;

var _Base = _interopRequireDefault(require("./Base.js"));

var _Collection = _interopRequireDefault(require("../Collection.js"));

var _CollectionEventType = _interopRequireDefault(require("../CollectionEventType.js"));

var _Event = _interopRequireDefault(require("../events/Event.js"));

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _ObjectEventType = _interopRequireDefault(require("../ObjectEventType.js"));

var _State = _interopRequireDefault(require("../source/State.js"));

var _asserts = require("../asserts.js");

var _obj = require("../obj.js");

var _extent = require("../extent.js");

var _util = require("../util.js");

var _events = require("../events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/layer/Group
 */


/**
 * @typedef {'addlayer'|'removelayer'} EventType
 */

/**
 * @classdesc
 * A layer group triggers 'addlayer' and 'removelayer' events when layers are added to or removed from
 * the group or one of its child groups.  When a layer group is added to or removed from another layer group,
 * a single event will be triggered (instead of one per layer in the group added or removed).
 */
var GroupEvent =
/** @class */
function (_super) {
  __extends(GroupEvent, _super);
  /**
   * @param {EventType} type The event type.
   * @param {BaseLayer} layer The layer.
   */


  function GroupEvent(type, layer) {
    var _this = _super.call(this, type) || this;
    /**
     * The added or removed layer.
     * @type {BaseLayer}
     * @api
     */


    _this.layer = layer;
    return _this;
  }

  return GroupEvent;
}(_Event["default"]);

exports.GroupEvent = GroupEvent;

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:layers', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|'change:layers', Return>} GroupOnSignature
 */

/**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|import("../Collection.js").default<import("./Base.js").default>} [layers] Child layers.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */

/**
 * @enum {string}
 * @private
 */
var Property = {
  LAYERS: 'layers'
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @api
 */

var LayerGroup =
/** @class */
function (_super) {
  __extends(LayerGroup, _super);
  /**
   * @param {Options} [opt_options] Layer options.
   */


  function LayerGroup(opt_options) {
    var _this = this;

    var options = opt_options || {};
    var baseOptions =
    /** @type {Options} */
    (0, _obj.assign)({}, options);
    delete baseOptions.layers;
    var layers = options.layers;
    _this = _super.call(this, baseOptions) || this;
    /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */

    _this.on;
    /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */

    _this.once;
    /***
     * @type {GroupOnSignature<void>}
     */

    _this.un;
    /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */

    _this.layersListenerKeys_ = [];
    /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */

    _this.listenerKeys_ = {};

    _this.addChangeListener(Property.LAYERS, _this.handleLayersChanged_);

    if (layers) {
      if (Array.isArray(layers)) {
        layers = new _Collection["default"](layers.slice(), {
          unique: true
        });
      } else {
        (0, _asserts.assert)(typeof
        /** @type {?} */
        layers.getArray === 'function', 43); // Expected `layers` to be an array or a `Collection`
      }
    } else {
      layers = new _Collection["default"](undefined, {
        unique: true
      });
    }

    _this.setLayers(layers);

    return _this;
  }
  /**
   * @private
   */


  LayerGroup.prototype.handleLayerChange_ = function () {
    this.changed();
  };
  /**
   * @private
   */


  LayerGroup.prototype.handleLayersChanged_ = function () {
    this.layersListenerKeys_.forEach(_events.unlistenByKey);
    this.layersListenerKeys_.length = 0;
    var layers = this.getLayers();
    this.layersListenerKeys_.push((0, _events.listen)(layers, _CollectionEventType["default"].ADD, this.handleLayersAdd_, this), (0, _events.listen)(layers, _CollectionEventType["default"].REMOVE, this.handleLayersRemove_, this));

    for (var id in this.listenerKeys_) {
      this.listenerKeys_[id].forEach(_events.unlistenByKey);
    }

    (0, _obj.clear)(this.listenerKeys_);
    var layersArray = layers.getArray();

    for (var i = 0, ii = layersArray.length; i < ii; i++) {
      var layer = layersArray[i];
      this.registerLayerListeners_(layer);
      this.dispatchEvent(new GroupEvent('addlayer', layer));
    }

    this.changed();
  };
  /**
   * @param {BaseLayer} layer The layer.
   */


  LayerGroup.prototype.registerLayerListeners_ = function (layer) {
    var listenerKeys = [(0, _events.listen)(layer, _ObjectEventType["default"].PROPERTYCHANGE, this.handleLayerChange_, this), (0, _events.listen)(layer, _EventType["default"].CHANGE, this.handleLayerChange_, this)];

    if (layer instanceof LayerGroup) {
      listenerKeys.push((0, _events.listen)(layer, 'addlayer', this.handleLayerGroupAdd_, this), (0, _events.listen)(layer, 'removelayer', this.handleLayerGroupRemove_, this));
    }

    this.listenerKeys_[(0, _util.getUid)(layer)] = listenerKeys;
  };
  /**
   * @param {GroupEvent} event The layer group event.
   */


  LayerGroup.prototype.handleLayerGroupAdd_ = function (event) {
    this.dispatchEvent(new GroupEvent('addlayer', event.layer));
  };
  /**
   * @param {GroupEvent} event The layer group event.
   */


  LayerGroup.prototype.handleLayerGroupRemove_ = function (event) {
    this.dispatchEvent(new GroupEvent('removelayer', event.layer));
  };
  /**
   * @param {import("../Collection.js").CollectionEvent} collectionEvent CollectionEvent.
   * @private
   */


  LayerGroup.prototype.handleLayersAdd_ = function (collectionEvent) {
    var layer =
    /** @type {import("./Base.js").default} */
    collectionEvent.element;
    this.registerLayerListeners_(layer);
    this.dispatchEvent(new GroupEvent('addlayer', layer));
    this.changed();
  };
  /**
   * @param {import("../Collection.js").CollectionEvent} collectionEvent CollectionEvent.
   * @private
   */


  LayerGroup.prototype.handleLayersRemove_ = function (collectionEvent) {
    var layer =
    /** @type {import("./Base.js").default} */
    collectionEvent.element;
    var key = (0, _util.getUid)(layer);
    this.listenerKeys_[key].forEach(_events.unlistenByKey);
    delete this.listenerKeys_[key];
    this.dispatchEvent(new GroupEvent('removelayer', layer));
    this.changed();
  };
  /**
   * Returns the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @return {!import("../Collection.js").default<import("./Base.js").default>} Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */


  LayerGroup.prototype.getLayers = function () {
    return (
      /** @type {!import("../Collection.js").default<import("./Base.js").default>} */
      this.get(Property.LAYERS)
    );
  };
  /**
   * Set the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @param {!import("../Collection.js").default<import("./Base.js").default>} layers Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */


  LayerGroup.prototype.setLayers = function (layers) {
    var collection = this.getLayers();

    if (collection) {
      var currentLayers = collection.getArray();

      for (var i = 0, ii = currentLayers.length; i < ii; ++i) {
        this.dispatchEvent(new GroupEvent('removelayer', currentLayers[i]));
      }
    }

    this.set(Property.LAYERS, layers);
  };
  /**
   * @param {Array<import("./Layer.js").default>} [opt_array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */


  LayerGroup.prototype.getLayersArray = function (opt_array) {
    var array = opt_array !== undefined ? opt_array : [];
    this.getLayers().forEach(function (layer) {
      layer.getLayersArray(array);
    });
    return array;
  };
  /**
   * Get the layer states list and use this groups z-index as the default
   * for all layers in this and nested groups, if it is unset at this point.
   * If opt_states is not provided and this group's z-index is undefined
   * 0 is used a the default z-index.
   * @param {Array<import("./Layer.js").State>} [opt_states] Optional list
   * of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */


  LayerGroup.prototype.getLayerStatesArray = function (opt_states) {
    var states = opt_states !== undefined ? opt_states : [];
    var pos = states.length;
    this.getLayers().forEach(function (layer) {
      layer.getLayerStatesArray(states);
    });
    var ownLayerState = this.getLayerState();
    var defaultZIndex = ownLayerState.zIndex;

    if (!opt_states && ownLayerState.zIndex === undefined) {
      defaultZIndex = 0;
    }

    for (var i = pos, ii = states.length; i < ii; i++) {
      var layerState = states[i];
      layerState.opacity *= ownLayerState.opacity;
      layerState.visible = layerState.visible && ownLayerState.visible;
      layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
      layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
      layerState.minZoom = Math.max(layerState.minZoom, ownLayerState.minZoom);
      layerState.maxZoom = Math.min(layerState.maxZoom, ownLayerState.maxZoom);

      if (ownLayerState.extent !== undefined) {
        if (layerState.extent !== undefined) {
          layerState.extent = (0, _extent.getIntersection)(layerState.extent, ownLayerState.extent);
        } else {
          layerState.extent = ownLayerState.extent;
        }
      }

      if (layerState.zIndex === undefined) {
        layerState.zIndex = defaultZIndex;
      }
    }

    return states;
  };
  /**
   * @return {import("../source/State.js").default} Source state.
   */


  LayerGroup.prototype.getSourceState = function () {
    return _State["default"].READY;
  };

  return LayerGroup;
}(_Base["default"]);

var _default = LayerGroup;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBZEE7Ozs7O0FBZ0JBOzs7O0FBSUE7Ozs7OztBQU1BO0FBQUE7QUFBQTtFQUFnQ0E7RUFDOUI7Ozs7OztFQUlBLG9CQUFZQyxJQUFaLEVBQWtCQyxLQUFsQixFQUF1QjtJQUF2QixZQUNFQyxrQkFBTUYsSUFBTixLQUFXLElBRGI7SUFHRTs7Ozs7OztJQUtBRyxLQUFJLENBQUNGLEtBQUwsR0FBYUEsS0FBYjs7RUFDRDs7RUFDSDtBQUFDLENBZkQsQ0FBZ0NHLGlCQUFoQzs7OztBQWlCQTs7Ozs7Ozs7QUFRQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQXNCQTs7OztBQUlBLElBQU1DLFFBQVEsR0FBRztFQUNmQyxNQUFNLEVBQUU7QUFETyxDQUFqQjtBQUlBOzs7Ozs7Ozs7QUFRQTtBQUFBO0FBQUE7RUFBeUJQO0VBQ3ZCOzs7OztFQUdBLG9CQUFZUSxXQUFaLEVBQXVCO0lBQXZCOztJQUNFLElBQU1DLE9BQU8sR0FBR0QsV0FBVyxJQUFJLEVBQS9CO0lBQ0EsSUFBTUUsV0FBVztJQUFHO0lBQXdCLGlCQUFPLEVBQVAsRUFBV0QsT0FBWCxDQUE1QztJQUNBLE9BQU9DLFdBQVcsQ0FBQ0MsTUFBbkI7SUFFQSxJQUFJQSxNQUFNLEdBQUdGLE9BQU8sQ0FBQ0UsTUFBckI7WUFFQVIsa0JBQU1PLFdBQU4sS0FBa0I7SUFFbEI7Ozs7SUFHQU4sS0FBSSxDQUFDUSxFQUFMO0lBRUE7Ozs7SUFHQVIsS0FBSSxDQUFDUyxJQUFMO0lBRUE7Ozs7SUFHQVQsS0FBSSxDQUFDVSxFQUFMO0lBRUE7Ozs7O0lBSUFWLEtBQUksQ0FBQ1csbUJBQUwsR0FBMkIsRUFBM0I7SUFFQTs7Ozs7SUFJQVgsS0FBSSxDQUFDWSxhQUFMLEdBQXFCLEVBQXJCOztJQUVBWixLQUFJLENBQUNhLGlCQUFMLENBQXVCWCxRQUFRLENBQUNDLE1BQWhDLEVBQXdDSCxLQUFJLENBQUNjLG9CQUE3Qzs7SUFFQSxJQUFJUCxNQUFKLEVBQVk7TUFDVixJQUFJUSxLQUFLLENBQUNDLE9BQU4sQ0FBY1QsTUFBZCxDQUFKLEVBQTJCO1FBQ3pCQSxNQUFNLEdBQUcsSUFBSVUsc0JBQUosQ0FBZVYsTUFBTSxDQUFDVyxLQUFQLEVBQWYsRUFBK0I7VUFBQ0MsTUFBTSxFQUFFO1FBQVQsQ0FBL0IsQ0FBVDtNQUNELENBRkQsTUFFTztRQUNMLHFCQUFPO1FBQVE7UUFBa0JaLE1BQUQsQ0FBU2EsUUFBbEMsS0FBZ0QsVUFBdkQsRUFBbUUsRUFBbkUsRUFESyxDQUNtRTtNQUN6RTtJQUNGLENBTkQsTUFNTztNQUNMYixNQUFNLEdBQUcsSUFBSVUsc0JBQUosQ0FBZUksU0FBZixFQUEwQjtRQUFDRixNQUFNLEVBQUU7TUFBVCxDQUExQixDQUFUO0lBQ0Q7O0lBRURuQixLQUFJLENBQUNzQixTQUFMLENBQWVmLE1BQWY7OztFQUNEO0VBRUQ7Ozs7O0VBR0FnQjtJQUNFLEtBQUtDLE9BQUw7RUFDRCxDQUZEO0VBSUE7Ozs7O0VBR0FEO0lBQ0UsS0FBS1osbUJBQUwsQ0FBeUJjLE9BQXpCLENBQWlDQyxxQkFBakM7SUFDQSxLQUFLZixtQkFBTCxDQUF5QmdCLE1BQXpCLEdBQWtDLENBQWxDO0lBRUEsSUFBTXBCLE1BQU0sR0FBRyxLQUFLcUIsU0FBTCxFQUFmO0lBQ0EsS0FBS2pCLG1CQUFMLENBQXlCa0IsSUFBekIsQ0FDRSxvQkFBT3RCLE1BQVAsRUFBZXVCLGdDQUFvQkMsR0FBbkMsRUFBd0MsS0FBS0MsZ0JBQTdDLEVBQStELElBQS9ELENBREYsRUFFRSxvQkFBT3pCLE1BQVAsRUFBZXVCLGdDQUFvQkcsTUFBbkMsRUFBMkMsS0FBS0MsbUJBQWhELEVBQXFFLElBQXJFLENBRkY7O0lBS0EsS0FBSyxJQUFNQyxFQUFYLElBQWlCLEtBQUt2QixhQUF0QixFQUFxQztNQUNuQyxLQUFLQSxhQUFMLENBQW1CdUIsRUFBbkIsRUFBdUJWLE9BQXZCLENBQStCQyxxQkFBL0I7SUFDRDs7SUFDRCxnQkFBTSxLQUFLZCxhQUFYO0lBRUEsSUFBTXdCLFdBQVcsR0FBRzdCLE1BQU0sQ0FBQ2EsUUFBUCxFQUFwQjs7SUFDQSxLQUFLLElBQUlpQixDQUFDLEdBQUcsQ0FBUixFQUFXQyxFQUFFLEdBQUdGLFdBQVcsQ0FBQ1QsTUFBakMsRUFBeUNVLENBQUMsR0FBR0MsRUFBN0MsRUFBaURELENBQUMsRUFBbEQsRUFBc0Q7TUFDcEQsSUFBTXZDLEtBQUssR0FBR3NDLFdBQVcsQ0FBQ0MsQ0FBRCxDQUF6QjtNQUNBLEtBQUtFLHVCQUFMLENBQTZCekMsS0FBN0I7TUFDQSxLQUFLMEMsYUFBTCxDQUFtQixJQUFJQyxVQUFKLENBQWUsVUFBZixFQUEyQjNDLEtBQTNCLENBQW5CO0lBQ0Q7O0lBQ0QsS0FBSzBCLE9BQUw7RUFDRCxDQXRCRDtFQXdCQTs7Ozs7RUFHQUQseURBQXdCekIsS0FBeEIsRUFBNkI7SUFDM0IsSUFBTTRDLFlBQVksR0FBRyxDQUNuQixvQkFDRTVDLEtBREYsRUFFRTZDLDRCQUFnQkMsY0FGbEIsRUFHRSxLQUFLQyxrQkFIUCxFQUlFLElBSkYsQ0FEbUIsRUFPbkIsb0JBQU8vQyxLQUFQLEVBQWNnRCxzQkFBVUMsTUFBeEIsRUFBZ0MsS0FBS0Ysa0JBQXJDLEVBQXlELElBQXpELENBUG1CLENBQXJCOztJQVVBLElBQUkvQyxLQUFLLFlBQVl5QixVQUFyQixFQUFpQztNQUMvQm1CLFlBQVksQ0FBQ2IsSUFBYixDQUNFLG9CQUFPL0IsS0FBUCxFQUFjLFVBQWQsRUFBMEIsS0FBS2tELG9CQUEvQixFQUFxRCxJQUFyRCxDQURGLEVBRUUsb0JBQU9sRCxLQUFQLEVBQWMsYUFBZCxFQUE2QixLQUFLbUQsdUJBQWxDLEVBQTJELElBQTNELENBRkY7SUFJRDs7SUFFRCxLQUFLckMsYUFBTCxDQUFtQixrQkFBT2QsS0FBUCxDQUFuQixJQUFvQzRDLFlBQXBDO0VBQ0QsQ0FuQkQ7RUFxQkE7Ozs7O0VBR0FuQixzREFBcUIyQixLQUFyQixFQUEwQjtJQUN4QixLQUFLVixhQUFMLENBQW1CLElBQUlDLFVBQUosQ0FBZSxVQUFmLEVBQTJCUyxLQUFLLENBQUNwRCxLQUFqQyxDQUFuQjtFQUNELENBRkQ7RUFJQTs7Ozs7RUFHQXlCLHlEQUF3QjJCLEtBQXhCLEVBQTZCO0lBQzNCLEtBQUtWLGFBQUwsQ0FBbUIsSUFBSUMsVUFBSixDQUFlLGFBQWYsRUFBOEJTLEtBQUssQ0FBQ3BELEtBQXBDLENBQW5CO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7RUFJQXlCLGtEQUFpQjRCLGVBQWpCLEVBQWdDO0lBQzlCLElBQU1yRCxLQUFLO0lBQUc7SUFDWnFELGVBQWUsQ0FBQ0MsT0FEbEI7SUFHQSxLQUFLYix1QkFBTCxDQUE2QnpDLEtBQTdCO0lBQ0EsS0FBSzBDLGFBQUwsQ0FBbUIsSUFBSUMsVUFBSixDQUFlLFVBQWYsRUFBMkIzQyxLQUEzQixDQUFuQjtJQUNBLEtBQUswQixPQUFMO0VBQ0QsQ0FQRDtFQVNBOzs7Ozs7RUFJQUQscURBQW9CNEIsZUFBcEIsRUFBbUM7SUFDakMsSUFBTXJELEtBQUs7SUFBRztJQUNacUQsZUFBZSxDQUFDQyxPQURsQjtJQUdBLElBQU1DLEdBQUcsR0FBRyxrQkFBT3ZELEtBQVAsQ0FBWjtJQUNBLEtBQUtjLGFBQUwsQ0FBbUJ5QyxHQUFuQixFQUF3QjVCLE9BQXhCLENBQWdDQyxxQkFBaEM7SUFDQSxPQUFPLEtBQUtkLGFBQUwsQ0FBbUJ5QyxHQUFuQixDQUFQO0lBQ0EsS0FBS2IsYUFBTCxDQUFtQixJQUFJQyxVQUFKLENBQWUsYUFBZixFQUE4QjNDLEtBQTlCLENBQW5CO0lBQ0EsS0FBSzBCLE9BQUw7RUFDRCxDQVREO0VBV0E7Ozs7Ozs7Ozs7RUFRQUQ7SUFDRTtNQUFPO01BQ0wsS0FBSytCLEdBQUwsQ0FBU3BELFFBQVEsQ0FBQ0MsTUFBbEI7SUFERjtFQUdELENBSkQ7RUFNQTs7Ozs7Ozs7OztFQVFBb0IsMkNBQVVoQixNQUFWLEVBQWdCO0lBQ2QsSUFBTWdELFVBQVUsR0FBRyxLQUFLM0IsU0FBTCxFQUFuQjs7SUFDQSxJQUFJMkIsVUFBSixFQUFnQjtNQUNkLElBQU1DLGFBQWEsR0FBR0QsVUFBVSxDQUFDbkMsUUFBWCxFQUF0Qjs7TUFDQSxLQUFLLElBQUlpQixDQUFDLEdBQUcsQ0FBUixFQUFXQyxFQUFFLEdBQUdrQixhQUFhLENBQUM3QixNQUFuQyxFQUEyQ1UsQ0FBQyxHQUFHQyxFQUEvQyxFQUFtRCxFQUFFRCxDQUFyRCxFQUF3RDtRQUN0RCxLQUFLRyxhQUFMLENBQW1CLElBQUlDLFVBQUosQ0FBZSxhQUFmLEVBQThCZSxhQUFhLENBQUNuQixDQUFELENBQTNDLENBQW5CO01BQ0Q7SUFDRjs7SUFFRCxLQUFLb0IsR0FBTCxDQUFTdkQsUUFBUSxDQUFDQyxNQUFsQixFQUEwQkksTUFBMUI7RUFDRCxDQVZEO0VBWUE7Ozs7OztFQUlBZ0IsZ0RBQWVtQyxTQUFmLEVBQXdCO0lBQ3RCLElBQU1DLEtBQUssR0FBR0QsU0FBUyxLQUFLckMsU0FBZCxHQUEwQnFDLFNBQTFCLEdBQXNDLEVBQXBEO0lBQ0EsS0FBSzlCLFNBQUwsR0FBaUJILE9BQWpCLENBQXlCLFVBQVUzQixLQUFWLEVBQWU7TUFDdENBLEtBQUssQ0FBQzhELGNBQU4sQ0FBcUJELEtBQXJCO0lBQ0QsQ0FGRDtJQUdBLE9BQU9BLEtBQVA7RUFDRCxDQU5EO0VBUUE7Ozs7Ozs7Ozs7O0VBU0FwQyxxREFBb0JzQyxVQUFwQixFQUE4QjtJQUM1QixJQUFNQyxNQUFNLEdBQUdELFVBQVUsS0FBS3hDLFNBQWYsR0FBMkJ3QyxVQUEzQixHQUF3QyxFQUF2RDtJQUNBLElBQU1FLEdBQUcsR0FBR0QsTUFBTSxDQUFDbkMsTUFBbkI7SUFFQSxLQUFLQyxTQUFMLEdBQWlCSCxPQUFqQixDQUF5QixVQUFVM0IsS0FBVixFQUFlO01BQ3RDQSxLQUFLLENBQUNrRSxtQkFBTixDQUEwQkYsTUFBMUI7SUFDRCxDQUZEO0lBSUEsSUFBTUcsYUFBYSxHQUFHLEtBQUtDLGFBQUwsRUFBdEI7SUFDQSxJQUFJQyxhQUFhLEdBQUdGLGFBQWEsQ0FBQ0csTUFBbEM7O0lBQ0EsSUFBSSxDQUFDUCxVQUFELElBQWVJLGFBQWEsQ0FBQ0csTUFBZCxLQUF5Qi9DLFNBQTVDLEVBQXVEO01BQ3JEOEMsYUFBYSxHQUFHLENBQWhCO0lBQ0Q7O0lBQ0QsS0FBSyxJQUFJOUIsQ0FBQyxHQUFHMEIsR0FBUixFQUFhekIsRUFBRSxHQUFHd0IsTUFBTSxDQUFDbkMsTUFBOUIsRUFBc0NVLENBQUMsR0FBR0MsRUFBMUMsRUFBOENELENBQUMsRUFBL0MsRUFBbUQ7TUFDakQsSUFBTWdDLFVBQVUsR0FBR1AsTUFBTSxDQUFDekIsQ0FBRCxDQUF6QjtNQUNBZ0MsVUFBVSxDQUFDQyxPQUFYLElBQXNCTCxhQUFhLENBQUNLLE9BQXBDO01BQ0FELFVBQVUsQ0FBQ0UsT0FBWCxHQUFxQkYsVUFBVSxDQUFDRSxPQUFYLElBQXNCTixhQUFhLENBQUNNLE9BQXpEO01BQ0FGLFVBQVUsQ0FBQ0csYUFBWCxHQUEyQkMsSUFBSSxDQUFDQyxHQUFMLENBQ3pCTCxVQUFVLENBQUNHLGFBRGMsRUFFekJQLGFBQWEsQ0FBQ08sYUFGVyxDQUEzQjtNQUlBSCxVQUFVLENBQUNNLGFBQVgsR0FBMkJGLElBQUksQ0FBQ0csR0FBTCxDQUN6QlAsVUFBVSxDQUFDTSxhQURjLEVBRXpCVixhQUFhLENBQUNVLGFBRlcsQ0FBM0I7TUFJQU4sVUFBVSxDQUFDUSxPQUFYLEdBQXFCSixJQUFJLENBQUNHLEdBQUwsQ0FBU1AsVUFBVSxDQUFDUSxPQUFwQixFQUE2QlosYUFBYSxDQUFDWSxPQUEzQyxDQUFyQjtNQUNBUixVQUFVLENBQUNTLE9BQVgsR0FBcUJMLElBQUksQ0FBQ0MsR0FBTCxDQUFTTCxVQUFVLENBQUNTLE9BQXBCLEVBQTZCYixhQUFhLENBQUNhLE9BQTNDLENBQXJCOztNQUNBLElBQUliLGFBQWEsQ0FBQ2MsTUFBZCxLQUF5QjFELFNBQTdCLEVBQXdDO1FBQ3RDLElBQUlnRCxVQUFVLENBQUNVLE1BQVgsS0FBc0IxRCxTQUExQixFQUFxQztVQUNuQ2dELFVBQVUsQ0FBQ1UsTUFBWCxHQUFvQiw2QkFDbEJWLFVBQVUsQ0FBQ1UsTUFETyxFQUVsQmQsYUFBYSxDQUFDYyxNQUZJLENBQXBCO1FBSUQsQ0FMRCxNQUtPO1VBQ0xWLFVBQVUsQ0FBQ1UsTUFBWCxHQUFvQmQsYUFBYSxDQUFDYyxNQUFsQztRQUNEO01BQ0Y7O01BQ0QsSUFBSVYsVUFBVSxDQUFDRCxNQUFYLEtBQXNCL0MsU0FBMUIsRUFBcUM7UUFDbkNnRCxVQUFVLENBQUNELE1BQVgsR0FBb0JELGFBQXBCO01BQ0Q7SUFDRjs7SUFFRCxPQUFPTCxNQUFQO0VBQ0QsQ0EzQ0Q7RUE2Q0E7Ozs7O0VBR0F2QztJQUNFLE9BQU95RCxrQkFBWUMsS0FBbkI7RUFDRCxDQUZEOztFQUdGO0FBQUMsQ0FyUUQsQ0FBeUJDLGdCQUF6Qjs7ZUF1UWUzRCxVIiwibmFtZXMiOlsiX19leHRlbmRzIiwidHlwZSIsImxheWVyIiwiX3N1cGVyIiwiX3RoaXMiLCJFdmVudCIsIlByb3BlcnR5IiwiTEFZRVJTIiwib3B0X29wdGlvbnMiLCJvcHRpb25zIiwiYmFzZU9wdGlvbnMiLCJsYXllcnMiLCJvbiIsIm9uY2UiLCJ1biIsImxheWVyc0xpc3RlbmVyS2V5c18iLCJsaXN0ZW5lcktleXNfIiwiYWRkQ2hhbmdlTGlzdGVuZXIiLCJoYW5kbGVMYXllcnNDaGFuZ2VkXyIsIkFycmF5IiwiaXNBcnJheSIsIkNvbGxlY3Rpb24iLCJzbGljZSIsInVuaXF1ZSIsImdldEFycmF5IiwidW5kZWZpbmVkIiwic2V0TGF5ZXJzIiwiTGF5ZXJHcm91cCIsImNoYW5nZWQiLCJmb3JFYWNoIiwidW5saXN0ZW5CeUtleSIsImxlbmd0aCIsImdldExheWVycyIsInB1c2giLCJDb2xsZWN0aW9uRXZlbnRUeXBlIiwiQUREIiwiaGFuZGxlTGF5ZXJzQWRkXyIsIlJFTU9WRSIsImhhbmRsZUxheWVyc1JlbW92ZV8iLCJpZCIsImxheWVyc0FycmF5IiwiaSIsImlpIiwicmVnaXN0ZXJMYXllckxpc3RlbmVyc18iLCJkaXNwYXRjaEV2ZW50IiwiR3JvdXBFdmVudCIsImxpc3RlbmVyS2V5cyIsIk9iamVjdEV2ZW50VHlwZSIsIlBST1BFUlRZQ0hBTkdFIiwiaGFuZGxlTGF5ZXJDaGFuZ2VfIiwiRXZlbnRUeXBlIiwiQ0hBTkdFIiwiaGFuZGxlTGF5ZXJHcm91cEFkZF8iLCJoYW5kbGVMYXllckdyb3VwUmVtb3ZlXyIsImV2ZW50IiwiY29sbGVjdGlvbkV2ZW50IiwiZWxlbWVudCIsImtleSIsImdldCIsImNvbGxlY3Rpb24iLCJjdXJyZW50TGF5ZXJzIiwic2V0Iiwib3B0X2FycmF5IiwiYXJyYXkiLCJnZXRMYXllcnNBcnJheSIsIm9wdF9zdGF0ZXMiLCJzdGF0ZXMiLCJwb3MiLCJnZXRMYXllclN0YXRlc0FycmF5Iiwib3duTGF5ZXJTdGF0ZSIsImdldExheWVyU3RhdGUiLCJkZWZhdWx0WkluZGV4IiwiekluZGV4IiwibGF5ZXJTdGF0ZSIsIm9wYWNpdHkiLCJ2aXNpYmxlIiwibWF4UmVzb2x1dGlvbiIsIk1hdGgiLCJtaW4iLCJtaW5SZXNvbHV0aW9uIiwibWF4IiwibWluWm9vbSIsIm1heFpvb20iLCJleHRlbnQiLCJTb3VyY2VTdGF0ZSIsIlJFQURZIiwiQmFzZUxheWVyIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9sYXllci9Hcm91cC5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==